import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon } from '../../../../components/Component'
import ReactDataTable from './ReactDataTable/ReactDataTable';
import { WEBSITE_BASE_URL } from '../../../../config';
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import { getStoreItemCategories } from '../../../../redux/admin/store/action';
import { toggleCategory } from '../../../../redux/admin/item/action';
import noimage from '../../../../assets/images/noimage.png';
import { useParams } from 'react-router';
import { ColorRing } from 'react-loader-spinner'
import ToastExample from '../../../../helpers/toast';
import { Image, Table } from 'antd';

function StoreItemCategories() {
    const { store_id } = useParams();

    const getSelectors = (state) => ({
        categories: state.store.store_item_categories,
    });
    const [loading, setLoading] = useState(false);
    const { categories } = useSelector(getSelectors);
    const dispatch = useDispatch();
    useEffect(() => {
        setLoading(true);
        dispatch(getStoreItemCategories(store_id)).then((response) => {
            setLoading(false);
        })
    }, [])
    const [showToast, setShowToast] = useState(false);   //toast state
    const handleCategoryStatus = (e, id) => {
        dispatch(toggleCategory(id));
        setTimeout(() => {
            dispatch(getStoreItemCategories(store_id));
            setShowToast(true);
        }, 500);

        setTimeout(() => {
            setShowToast(false);
        }, 3000);
    };

    // const [storeItemCategoriesTableDatas, setStoreItemCategoriesTableDatas] = useState([])
    // useEffect(() => {
    //     if (categories && categories.length > 0) {
    //         const datas = [];
    //         if (categories.length) {
    //             categories?.map((item) => {
    //                 datas.push({
    //                     id: item.id,
    //                     name: item.name,
    //                     type: item.type,
    //                     image: (
    //                         <div className="user-card mt-2 mb-2">
    //                             <Image
    //                                 style={{ width: '6rem', borderRadius: "5px" }}
    //                                 src={item?.image ? item?.image : noimage}
    //                             />
    //                         </div>
    //                     ),
    //                     items: item?.items?.length,
    //                     status: (
    //                         <Button color={item.is_active ? "success" : "danger"}
    //                             onClick={(e) => handleCategoryStatus(e, item.id)}
    //                         >
    //                             {item.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
    //                         </Button>
    //                     ),
    //                 });
    //                 return item;
    //             });
    //             if (datas.length) setStoreItemCategoriesTableDatas(datas);
    //         } else {
    //             setStoreItemCategoriesTableDatas([]);
    //         }
    //     }
    // }, [categories]);


    const dataTableColumns = [
        {
            name: "Name",
            selector: (row) => row.name,
            sortable: true,
        },
        {
            name: "Image",
            selector: (row) => row.image,
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <Image
                        style={{
                            width: "15vh",
                            objectFit: 'cover',
                        }}
                        src={row?.image ? row?.image : noimage}
                    />
                </div>
            )
        },
        // {
        //     name: "Type",
        //     selector: (row) => row.type,
        //     sortable: true,
        // },
        {
            name: "Items",
            selector: (row) => row?.items?.length,
        },
        {
            name: "Status",
            selector: (row) => row.startDate,
            cell: (row) => (
                <Button color={row?.is_active ? "success" : "danger"} onClick={(e) => {
                    handleCategoryStatus(e, row?.id)
                }}>
                    {row?.is_active ? <Icon name="stop-circle-fill" /> : <Icon name="play-circle-fill" />}
                </Button>
            )
        },
        // {
        //     name: "Action",
        //     selector: (row) => row.salary,
        //     cell: (row) => (
        //         <div className="user-card mt-2 mb-2">
        //             <DropdownTrans row={row} />
        //         </div>
        //     )
        // },
    ];


    return (
        <React.Fragment>
            <Head title="Store Item Categories"></Head>
            {loading ?
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
                :
                <Content>
                    <BlockHead size="sm">
                        <BlockBetween>
                            <BlockHeadContent>
                                <BlockTitle tag="h3" page>
                                    Store Item Categories
                                </BlockTitle>
                                <BlockDes className="text-soft">
                                    <p>You have total {categories?.length} Item Categories.</p>
                                </BlockDes>
                            </BlockHeadContent>
                            <BlockHeadContent>
                                <div className="toggle-wrap nk-block-tools-toggle">
                                    <ToastExample
                                        show={showToast}
                                    />
                                </div>
                            </BlockHeadContent>
                        </BlockBetween>
                    </BlockHead>

                    <ReactDataTable data={categories} columns={dataTableColumns} expandableRows pagination />
                </Content>
            }
        </React.Fragment>
    )
}

export default StoreItemCategories
